import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-legal-entity-information',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './legal-entity-information.component.html',
  styleUrl: './legal-entity-information.component.scss',
})
export class LegalEntityInformationComponent {
  @Input() entityId: number | null = null;
}
